import { ContainerPadding, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useState } from 'react';
import { CtasRadio } from '../../../components/inputs-group/inputs/core/ctas-radio';
import { Carousel } from '../../../components/screen/carousel';
import { Section } from '../../../components/screen/section';
import { FIELD_NAME } from '../../../constants/form-constants';
import { CallMeEnvioSection } from './call-me-envio-section';

interface Props {
	formData: () => Promise<any> | Record<string, any>;
	showPerfilado?: boolean;
	showComunicacionesComerciales?: boolean;
	paddingTop?: ContainerPadding;
	paddingBottom?: ContainerPadding;
}

export function CallMeConsentimientosEnvioSection(props: Props) {
	const { formData, showPerfilado, showComunicacionesComerciales, paddingTop, paddingBottom } = props;
	const [tabAccess, setTabAccess] = useState(false);

	const options = [
		{
			value: 'PERMITE',
			text: 'Aceptar',
			selectedText: 'Aceptado',
			emphasis: 'primary' as const,
		},
		{ value: 'NO INFORMADO', text: 'Omitir' },
	];

	const slides = [
		showPerfilado && (
			<>
				<Section paddingBottom={ContainerPadding.static300}>
					<Text bold appearance={TokenTextAppearance.headline200}>
						Privacidad
					</Text>
				</Section>
				<Section paddingTop={paddingTop} paddingBottom={paddingBottom}>
					<Text bold appearance={TokenTextAppearance.headline200}>
						¿Te gustaría que elaboremos un perfil tuyo para ofrecerte información comercial sobre productos y servicios
						de nuestras marcas que creamos que te puedan interesar más según tus preferencias?
					</Text>
					<Text appearance={TokenTextAppearance.copy100}>
						Activando esta opción podremos enviarte información y ofertas personalizadas de productos y servicios
						adecuadas a tu perfil. Para ello nos basaremos en tu comportamiento, preferencias personales y cómo usas
						nuestros productos y servicios.
					</Text>
					<CtasRadio name={FIELD_NAME.RGPD_PERFILADO} options={options} size="large" required enableOnClick />
				</Section>
			</>
		),
		showComunicacionesComerciales && (
			<>
				<Section paddingBottom={ContainerPadding.static300}>
					<Text bold appearance={TokenTextAppearance.headline200}>
						Privacidad
					</Text>
				</Section>
				<Section paddingTop={paddingTop} paddingBottom={paddingBottom}>
					<Text bold appearance={TokenTextAppearance.headline200}>
						¿Te gustaría recibir descuentos y novedades de Volkswagen?
					</Text>
					<Text appearance={TokenTextAppearance.copy100}>
						Si nos das tu consentimiento desde Volkswagen Group España Distribución, S.A.U. como responsable de la marca
						Volkswagen podremos enviarte por cualquier medio, ya sea por teléfono, correo electrónico, sms o
						aplicaciones de mensajería instantánea información comercial lo que puede incluir, a título enunciativo,
						pero no limitativo, descuentos, novedades, próximos lanzamientos, invitaciones a eventos o a concursos,
						entre otras comunicaciones comerciales.
					</Text>
					<CtasRadio
						name={FIELD_NAME.RGPD_COMUNICACIONES_COMERCIALES}
						options={options}
						size="large"
						required
						enableOnClick
					/>
				</Section>
			</>
		),
		<CallMeEnvioSection
			formData={formData}
			title="¿Listo para enviar?"
			tabAccess={tabAccess}
			errorMessage={undefined}
		/>,
	].filter(Boolean) as [React.ReactNode]; // Filtramos los valores null o undefined

	const handleSlideChange = (index: number) => {
		if (index === slides.length - 1) {
			setTabAccess(true);
		}
	};

	return <Carousel slides={slides} onChange={handleSlideChange} />;
}
